module.exports = __webpack_public_path__ + "static/media/arrow.e7180992.png";